import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(1),
      minHeight: '0',
      display: 'flex',
      flexDirection: 'column',

      flex: 1,

      '& > div:first-child': {
        height: '100%',
        minHeight: '0',
        overflowY: 'auto',

        '& > h4': {
          color: theme.palette.text.secondary,
          marginTop: theme.spacing(2),
          fontWeight: 500,
        },
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      padding: theme.spacing(2, 1, 3, 1),
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(2),

      '& > button': {
        width: 'auto',
        height: 'auto',
        margin: '0',
        padding: '1rem 1.5rem',
        minWidth: '10rem',
      },
    },
  }),
)
